import api from "../store/services/api";

export const getCredentials = async (params) =>
  await api.get("/uber/credentials/", { params });

export const createCredentials = async (credential) =>
  await api.post("/uber/credentials/", credential, {
    headers: { "Content-Type": "application/json" },
  });

export const editCredentials = async (credentialId, credential) =>
  await api.put(`/uber/credentials/${credentialId}/`, credential, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteCredential = async (credentialId) =>
  await api.delete(`/uber/credentials/${credentialId}`);

export const validateCredentials = async (credential) =>
  await api.post("/uber/credentials/validate/", credential, {
    headers: { "Content-Type": "application/json" },
  });

export const createQuote = async (quoteData) =>
  await api.post("/uber/quotes/", quoteData, {
    headers: { "Content-Type": "application/json" },
  });

export const createDelivery = async (deliveryData) =>
  await api.post("/uber/deliveries/", deliveryData, {
    headers: { "Content-Type": "application/json" },
  });

export const getDeliveryStatus = async (deliveryId) =>
  await api.get(`/uber/deliveries/${deliveryId}/`);

export const cancelDelivery = async (deliveryId) =>
  await api.post(`/uber/deliveries/${deliveryId}/cancel/`);

const UberService = {
  getCredentials,
  createCredentials,
  editCredentials,
  deleteCredential,
  validateCredentials,
  createQuote,
  createDelivery,
  getDeliveryStatus,
  cancelDelivery,
};

export default UberService;
